import { store } from '../redux/store';
import { setEditControl } from '../redux/slices/editControlSlice';

/**
 * Check if edit mode is enabled in URL
 */
const isEditModeInUrl = (): boolean => {
  const pathname = window.location.pathname;
  
  // Check for edit route pattern: /restaurantId/preview/edit
  return pathname.includes('/preview/edit');
};

/**
 * Get restaurantId from URL path or query parameters
 */
const getRestaurantIdFromQuery = (): string | null => {
  // First try to get from URL path (e.g., /{restaurantId}/preview)
  const pathSegments = window.location.pathname.split('/').filter(Boolean);
  if (pathSegments.length > 0) {
    const firstSegment = pathSegments[0];
    // Check if it looks like a restaurant ID (UUID format)
    if (firstSegment.match(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i)) {
      return firstSegment;
    }
  }
  
  // Fallback to query parameters for backward compatibility
  const urlParams = new URLSearchParams(window.location.search);
  let restaurantId = urlParams.get('restaurantId');
  
  // If restaurantId is not found, check for restaurantId_parent_id
  if (!restaurantId) {
    const rawRestaurantId = urlParams.get('restaurantId_parent_id');
    restaurantId = rawRestaurantId?.split('?')[0] || null;
  }
  
  return restaurantId;
};

/**
 * Main function to validate and enable edit control
 */
export const checkAndValidateEditControl = (restaurantId: string | null): void => {
  const editMode = isEditModeInUrl();
  const urlRestaurantId = getRestaurantIdFromQuery();

  console.log('🔍 Edit Control Check:', { editMode, urlRestaurantId, restaurantId });

  if (editMode && urlRestaurantId && restaurantId) {
    if (restaurantId === urlRestaurantId) {
      store.dispatch(setEditControl(true));
      console.log('✅ Edit Mode Enabled for:', urlRestaurantId);
    } else {
      store.dispatch(setEditControl(false));
      console.log('⚠️ Restaurant ID mismatch. Restaurant:', restaurantId, 'URL:', urlRestaurantId);
    }
  } else if (editMode || urlRestaurantId) {
    // Only set to false if we actually had edit parameters but they don't match
    store.dispatch(setEditControl(false));
    console.log('❌ Edit mode disabled - parameters don\'t match');
  }
  // Don't set to false if there are no edit parameters at all (let existing state persist)
};
